import {LinePlanItems} from "./LinePlanItems";


/// <summary>
/// 公交换乘信息
/// </summary>
export class BusTransferInfo {

	constructor() {
		this.hasSubway = false;
		this.lineType = -1;
		this.plans = new LinePlanItems();
	}

	static GetTransferInfo(jsonObj) {
		let transferInfo=null;
		if(jsonObj==null)return transferInfo;
		transferInfo =new BusTransferInfo();

		let jsonResultNodeObj= jsonObj.results;
		if(!jsonResultNodeObj || jsonResultNodeObj.length===0)return transferInfo; 
		let firstNodeObj=jsonResultNodeObj[0];
		
		transferInfo.hasSubway=jsonObj.hasSubway;
		transferInfo.lineType=firstNodeObj.lineType;
		transferInfo.plans =LinePlanItems.GetLinePlanItems( firstNodeObj.lines);

		return transferInfo;
	}

}//end BusTransferInfo

